import React, {Dispatch, SetStateAction} from 'react';
import UserTeamFilterButton from './UserTeamFilterButton';
import {FilterModeType} from '../../../PersonalOffice/MyTeam/MyTeam';
import {useGetMyTeamHeaderQuery} from '../../../redux/userClientsApi';
import {useTranslation} from 'react-i18next';
import PreLoaderComponent from '../../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import s from './UserTeamHeader.module.css';

interface Props {
	month: string;
	setFilters: Dispatch<SetStateAction<any>>;
	onFilterChange?: () => void;
}

export type UserTeamButtonProps = {
	count: number;
	color: 'brown' | 'green' | 'blue';
	text: string;
	callback: (type: FilterModeType) => void;
	type: FilterModeType;
};

const UserTeamHeader: React.FC<Props> = ({
	month,
	setFilters,
	onFilterChange,
}) => {
	const {t} = useTranslation();
	const {data: teamHeader, isLoading} = useGetMyTeamHeaderQuery(month);

	const buttons: Omit<UserTeamButtonProps, 'callback'>[] = [
		{
			count: teamHeader?.count_all ?? 0,
			color: 'brown',
			text: t('Моя команда'),
			type: 'all',
		},
		{
			count: teamHeader?.count_mn ?? 0,
			color: 'green',
			text: t('Партнери у кваліфікації'),
			type: 'manager_type',
		},
		{
			count: teamHeader?.count_optima ?? 0,
			color: 'blue',
			text: t('Кліенти Optima'),
			type: 'optima_type',
		},
	];
	const handleChangeFilter = (type: FilterModeType) => {
		if (type === 'all') {
			setFilters({
				non_filter: true,
				month,
			});
		} else {
			setFilters({
				non_filter: false,
				month,
				[type]: true,
			});
		}
		onFilterChange?.();
	};
	if (isLoading) {
		return <PreLoaderComponent type={'gallery'} size={'big'} />;
	}
	return (
		<>
			{teamHeader && (
				<div className={s.userTeamActions}>
					{buttons.map((button, index: number) => (
						<UserTeamFilterButton
							key={`UserTeamButtonPropsWithoutCallback${index}`}
							text={button.text}
							color={button.color}
							type={button.type}
							count={button.count}
							callback={handleChangeFilter}
						/>
					))}
				</div>
			)}
		</>
	);
};

export default UserTeamHeader;
